import { LatestItemsUsage } from "../../models/local-storage/latest-items-usage.model";
import { StpViewerConfig } from "../../models/local-storage/stp-viewer-config.model";

const latestItemsUsageKey: string = 'LatestItemsUsage';

const saveLatestItemsUsage = (model: LatestItemsUsage): void  => {
    localStorage.setItem(latestItemsUsageKey, JSON.stringify(model))
}

const getLatestItemsUsage = (): LatestItemsUsage  => {
    const model: string | null = localStorage.getItem(latestItemsUsageKey);
    if (model) {
        return JSON.parse(model);
    }
    const newModel: LatestItemsUsage = new LatestItemsUsage();
    saveLatestItemsUsage(newModel);
    return newModel;
}

export const getStpViewerConfig = (): StpViewerConfig  => {
    const latestItemsUsage: LatestItemsUsage = getLatestItemsUsage();
    if (latestItemsUsage.stpViewerConfig) {
        return latestItemsUsage.stpViewerConfig;
    }
    const stpViewerConfig: StpViewerConfig = new StpViewerConfig();
    latestItemsUsage.stpViewerConfig = stpViewerConfig;
    saveLatestItemsUsage(latestItemsUsage);
    return stpViewerConfig;
}

export const setStpViewer3dMode = (is3dMode: boolean): void  => {
    const latestItemsUsage: LatestItemsUsage = getLatestItemsUsage();
    latestItemsUsage.stpViewerConfig.is3dMode = is3dMode;
    saveLatestItemsUsage(latestItemsUsage);
}